import { handleRoute } from "../https";

export async function findAlerts(companyId) {
  const res = await handleRoute({
    method: "get",
    path: `v1/companies/${companyId}/alerts`,
  });
  return res;
}
